module.exports = __webpack_public_path__ + "static/media/logo.645bc513.svg";